import { render, staticRenderFns } from "./MapManagementModuleRoot.vue?vue&type=template&id=8b3f545c&scoped=true&lang=html&"
import script from "./MapManagementModuleRoot.vue?vue&type=script&lang=js&"
export * from "./MapManagementModuleRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3f545c",
  null
  
)

export default component.exports